var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-profile-territorial';
                    var viewUrl = 'sprite.svg#view-icon-profile-territorial';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 89 56',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };